export function formatIncidentRuleDuration(seconds: number | undefined | null) {
  if (seconds === undefined || seconds === null) {
    return '';
  }

  if (seconds === 0) {
    return 'fires immediately';
  }

  return `FOR ${Math.round(seconds / 60)} min`;
}
